import { Select } from 'antd';
import { OrderGenerateForMemberDto } from 'types/oms';
import i18n from '../../../i18n';
import {
  ORDER_CREATE_SOURCE_MAP,
  getOrderCreateSourceConfig,
} from 'constant/order-create-source';

type Props = {
  setPayload: (
    data: Partial<Pick<OrderGenerateForMemberDto, 'createdFrom'>>,
  ) => void;
} & Partial<Pick<OrderGenerateForMemberDto, 'createdFrom'>>;

const CreatedSelect = ({ setPayload, createdFrom }: Props) => {
  return (
    <Select
      value={createdFrom}
      size="large"
      placeholder={i18n.t('enter_order_source')}
      onChange={(e) => {
        setPayload({ createdFrom: e });
      }}
      listHeight={300}
      options={[
        ORDER_CREATE_SOURCE_MAP.WEBSITE,
        ORDER_CREATE_SOURCE_MAP.GINZA,
        ORDER_CREATE_SOURCE_MAP.HONGKONG,
        ORDER_CREATE_SOURCE_MAP.SINGAPORE,
        ORDER_CREATE_SOURCE_MAP.DUBAI,
        ORDER_CREATE_SOURCE_MAP.FRANCE,
        ORDER_CREATE_SOURCE_MAP.NEW_YORK,
        ORDER_CREATE_SOURCE_MAP.WHATSAPP,
        ORDER_CREATE_SOURCE_MAP.INSTAGRAM,
        ORDER_CREATE_SOURCE_MAP.LINE,
        ORDER_CREATE_SOURCE_MAP.WECHAT,
        ORDER_CREATE_SOURCE_MAP.OTHER,
      ].map((d) => ({
        value: d,
        label: getOrderCreateSourceConfig(d).label,
      }))}
    ></Select>
  );
};

export default CreatedSelect;
